const PROJECT_TITLE_KEYWORDS = [
	'project',
	'overview',
	'poster',
	'brief',
	'scope',
	'plan',
	'launch',
	'strategy',
];

const titleContainsProjectKeyword = (contentTitle: string): boolean => {
	const lowerTitle = contentTitle.toLowerCase();
	return PROJECT_TITLE_KEYWORDS.some((keyword) => lowerTitle.includes(keyword));
};

/**
 * Determines whether the "Get Project Overview" skill action should be shown.
 *
 * Conditions:
 * - Must be a page (not a blogpost, whiteboard, database, etc.)
 * - Page title contains a project-related keyword
 */
export const shouldShowGetProjectOverviewAction = ({
	contentType,
	contentTitle,
}: {
	contentType: string;
	contentTitle?: string;
}): boolean => {
	if (contentType !== 'page') {
		return false;
	}

	return Boolean(contentTitle && titleContainsProjectKeyword(contentTitle));
};
